export default __webpack_public_path__ + "static/media/qrMasterbox.646139e5.jpg";